import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation CreateHubspotIntegrationMutation($input: CreateHubspotIntegrationInput!) {
		createHubspotIntegration(input: $input) {
			redirectUrl
			errors
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	return commitMutation(environment, {
		mutation,
		variables: {
			input: {
				socketClientId: Util.getClientId(),
				...input,
			},
		},
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
